import { useCallback } from 'react'
import {
	ApiPostWithToken,
	useApiPost
} from 'shared/api'
import {
  targetListApiBy
} from 'interface/endpoints'
import {
	KojinAnnotateFormData,
	KojinAnnotateResult
} from './types'

export * from './types'

export const usePostKojinAnnotate = (
	searchId: number,
	targetListId: number, 
	kojinCode?: string,
  callback?: {
    onPosted?: (result: KojinAnnotateResult) => void
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onError?: (reason: any) => void
  }
) => useApiPost<KojinAnnotateFormData, KojinAnnotateResult>(
	useCallback(
		(apiAccess, cancelToken, form, webSocketId) => {
			if (!kojinCode) return null
			return ApiPostWithToken(
				apiAccess,
        targetListApiBy(searchId, targetListId, `/kojin/${kojinCode}/annotate`),
				form,
				cancelToken,
				webSocketId
			)
		},
		[searchId, targetListId, kojinCode]
	),
	useCallback(
		(result) => {
			if (callback?.onPosted) callback.onPosted(result)
			return result
		},
		[callback]
	),
	useCallback(
		(reason) => {
      if (callback?.onError) callback?.onError(reason)
		},
		[callback]
	)
)
